(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();

      // Reorder menus after theme snippets render
      try { window.__reorderMenus && window.__reorderMenus(); } catch(e){}
    }
    setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback(){
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver(){
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect; observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal){ requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top){
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
    closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d => d.close()); }
    closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  // --- Keep hover SVGs by leaving original snippets alone; reorder via DOM ---
  (function(){
    const ORDER = ['about','shop','projects','contacts'];
    function normalize(txt){ return (txt||'').trim().toLowerCase(); }
    function isPhilosophy(txt){ return normalize(txt) === 'philosophy'; }

    function reorderInlineMenu(){
      const nav = document.querySelector('.header__inline-menu > ul, nav.header__inline-menu > ul, .header__inline-menu .list-menu--inline');
      if(!nav) return;

      const items = Array.from(nav.children);
      // Remove philosophy
      items.forEach(li => {
        const a = li.querySelector('a');
        const label = a ? normalize(a.textContent) : '';
        if (isPhilosophy(label)) li.remove();
      });

      // Reorder by desired order
      const map = new Map();
      Array.from(nav.children).forEach(li => {
        const a = li.querySelector('a');
        if(!a) return;
        const label = normalize(a.textContent);
        map.set(label, li);
      });

      const frag = document.createDocumentFragment();
      ORDER.forEach(key => {
        const li = map.get(key);
        if (li) frag.appendChild(li);
      });
      // append any remaining items (if any)
      Array.from(nav.children).forEach(li => frag.appendChild(li));
      nav.innerHTML = '';
      nav.appendChild(frag);
    }

    function reorderDrawerMenu(){
      // Dawn drawer top-level list (works for both dropdown & mega)
      const lists = document.querySelectorAll('.menu-drawer__navigation .menu-drawer__menu, .menu-drawer__navigation [role="list"]');
      lists.forEach(ul => {
        const items = Array.from(ul.children);
        items.forEach(li => {
          const a = li.querySelector('a, button');
          const label = a ? normalize(a.textContent) : '';
          if (isPhilosophy(label)) li.remove();
        });

        const map = new Map();
        Array.from(ul.children).forEach(li => {
          const a = li.querySelector('a, button');
          if(!a) return;
          const label = normalize(a.textContent);
          map.set(label, li);
        });

        const frag = document.createDocumentFragment();
        ORDER.forEach(key => { const li = map.get(key); if (li) frag.appendChild(li); });
        Array.from(ul.children).forEach(li => frag.appendChild(li));
        ul.innerHTML = '';
        ul.appendChild(frag);
      });
    }

    function run(){
      reorderInlineMenu();
      reorderDrawerMenu();
    }

    // expose for sticky-header to call post-render
    window.__reorderMenus = run;

    // run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    // also re-run when the drawer opens (some themes lazy-render it)
    document.addEventListener('click', (e) => {
      const t = e.target.closest('header-drawer, .menu-drawer, [aria-controls="menu-drawer"], [data-action="open-drawer"]');
      if (t) setTimeout(run, 50);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
